/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'

import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { MF } from 'components/MF'

// TODO Set the correct article ID here
const ARTICLE_ID = '00000000'

export function AppComponent() {
  return (
    <div className='index'>
      <ThemeSwitch />
      <MF />
    </div>
  )
}
